import type { TrustGrade } from "./types";

/** Most and least sensitive grade in a set (lower number = more sensitive). */
export function gradeRange(
  grades: Array<TrustGrade | null | undefined>,
): { most: TrustGrade; least: TrustGrade } | null {
  const known = grades.filter((g): g is TrustGrade => g !== null && g !== undefined);
  if (known.length === 0) return null;
  return {
    most: Math.min(...known) as TrustGrade,
    least: Math.max(...known) as TrustGrade,
  };
}
